import React from 'react';
import { Icon, Text } from '@upsales/components';
import SupersearchResultHeader from 'Components/Supersearch/SupersearchResultHeader';
import T from 'Components/Helpers/translate';
import { useAddActions } from 'App/components/AppSidebar/useAddActions';
import { useCreateActionContext } from './useCreateActionContext';

type Props = {
	closeSearch: () => void;
	query?: string;
};

const SupersearchActions = ({ closeSearch, query }: Props) => {
	const context = useCreateActionContext();
	const search = (query || '').trim().toLowerCase();
	const actions = useAddActions(context).filter(
		action => action.show && (!search || T(action.title).toLowerCase().includes(search))
	);

	if (!actions.length) {
		return null;
	}

	return (
		<div className="SupersearchActions">
			<SupersearchResultHeader title={T('default.create')} icon="plus" />
			{actions.map(action => (
				<div
					key={action.type}
					className="SupersearchResultRow"
					onClick={() => {
						closeSearch();
						action.do();
					}}
				>
					<Text size="md">
						{action.icon ? <Icon name={action.icon} space="mrm" /> : null}
						{T(action.title)}
					</Text>
				</div>
			))}
		</div>
	);
};

export default SupersearchActions;
